export const DETAILS_ITEM = 'DETAILS_ITEM';